import { service } from '../axios';
/** 根据业务申请编号查询实验室业务申请详情*/
export function getLabBusinessApply(params) {
    return service({
        url: '/labBusinessApply/getApplyRecord',
        method: 'get',
        params
    });
}
/** 保存或更新实验室业务申请（主子表联动保存）*/
export function saveLabBusinessApply(data) {
    return service({
        url: '/labBusinessApply/saveApplyRecord',
        method: 'post',
        data
    });
}
export function saveLabRiskRecord(data) {
    return service({
        url: '/riskAudit/saveLabRiskRecord',
        method: 'post',
        data,
    });
}
export function getLabRiskRecord(params) {
    return service({
        url: '/riskAudit/getLabRiskRecord',
        method: 'get',
        params
    });
}
export function submitLabLabExamRequire(data) {
    return service({
        url: '/labControl/saveLabExamRequire',
        method: 'post',
        data
    });
}
export function saveLabCourseRisks(data) {
    return service({
        url: '/labControl/saveLabCourseRisks',
        method: 'post',
        data
    });
}
export function loadLabSafetyCheckItems(labId) {
    return service({
        url: '/safety/inspection/listByLabId',
        method: 'get',
        params: { labId }
    });
}
export function addBatchLabAccessRule(data) {
    return service({
        url: '/labUserAccess/addBatchLabAccessRule',
        method: 'post',
        data
    });
}
export function addLabAccessRule(data) {
    return service({
        url: '/labUserAccess/addRule',
        method: 'post',
        data
    });
}
export function deleteLabAccessRule(id) {
    return service({
        url: `/labUserAccess/Rule/${id}`,
        method: 'delete'
    });
}
export function addLabUserOverride(data) {
    return service({
        url: '/labUserAccess/addLabUserOverride',
        method: 'post',
        data
    });
}
export function deleteLabOverride(params) {
    return service({
        url: `/labUserAccess/deleteLabOverride`,
        method: 'delete',
        params
    });
}
export function getMyStudentSchedule(params) {
    return service({
        url: '/courseSchedule/getMyStudentSchedule',
        method: 'get',
        params
    });
}
export function getCourseSchedule(params) {
    return service({
        url: '/courseSchedule/getSchedule',
        method: 'get',
        params
    });
}
export function getReservationSchedules(params) {
    return service({
        url: '/courseSchedule/getReservationSchedules',
        method: 'get',
        params
    });
}
export function getLabBaseLabOrCourse(params) {
    return service({
        url: '/courseSchedule/getLabBaseLabOrCourse',
        method: 'get',
        params
    });
}
export function generateCourseConsApply(params) {
    return service({
        url: '/cons/stockOut/generateCourseApply',
        method: 'post',
        params
    });
}
export function uploadLabBaseExcel(file, bizType) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('bizType', bizType);
    return service({
        url: '/labImport/uploadExcel',
        method: 'post',
        data: formData,
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}
export function searchLab(params) {
    return service({
        url: '/lab/search',
        method: 'get',
        params
    });
}
export function offlineLab(params) {
    return service({
        url: '/lab/offline',
        method: 'post',
        params
    });
}
export function batchSaveLabInfo(data) {
    return service({
        url: '/labControl/batchSaveLabInfo',
        method: 'post',
        data
    });
}
export function getLabListByOrg(params) {
    return service({
        url: '/lab/getLabListByOrg',
        method: 'get',
        params
    });
}
export function getCountOfflineLab(params) {
    return service({
        url: '/lab/getCountOfflineLab',
        method: 'get',
        params
    });
}
export function getLabSelectedList(params) {
    return service({
        url: '/lab/getLabSelectedList',
        method: 'get',
        params
    });
}
export function getLabOrgList(params) {
    return service({
        url: '/lab/labOrgList',
        method: 'get',
        params
    });
}
export function getLocationHierarchy() {
    return service({
        url: '/lab/getLocationHierarchy',
        method: 'get',
    });
}
export function getLabReservationPolicy(params) {
    return service({
        url: '/reservation/getLabReservationPolicy',
        method: 'get',
        params
    });
}
export function saveReservationPolicy(data) {
    return service({
        url: '/reservation/saveReservationPolicy',
        method: 'post',
        data
    });
}
export function saveNoticeLabScope(data) {
    return service({
        url: '/lab/notice/saveScope',
        method: 'post',
        data
    });
}
export function getNoticeLabScope(noticeId) {
    return service({
        url: '/lab/notice/getScope',
        method: 'get',
        params: { noticeId }
    });
}
export function getNoticeList(data) {
    return service({
        url: '/lab/notice/list',
        method: 'post',
        data
    });
}
export function getNoticeDetail(noticeId) {
    return service({
        url: '/lab/notice/detail',
        method: 'get',
        params: { noticeId }
    });
}
export function getLocationTree(params) {
    return service({
        url: '/lab/location/tree',
        method: 'get',
        params
    });
}
export function getLocationList(params) {
    return service({
        url: '/lab/location/list',
        method: 'get',
        params
    });
}
export function saveLocation(data) {
    return service({
        url: '/lab/location/save',
        method: 'post',
        data
    });
}
export function deleteLocation(labLocationId) {
    return service({
        url: `/lab/location/${labLocationId}`,
        method: 'delete'
    });
}
export function bindLocationLab(data) {
    return service({
        url: '/lab/location/bindLab',
        method: 'post',
        params: data
    });
}
